import { Button } from '@monksflow/monks-ui';
import { UploadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@/shared/ui/SearchInput';
import type { CollectionFilesToolbarProps } from './CollectionFilesToolbar.types';

export function CollectionFilesToolbar({
  searchQuery,
  onSearchChange,
  onUpload,
  canUpload,
}: CollectionFilesToolbarProps) {
  const { t } = useTranslation('knowledge');

  return (
    <div
      data-testid="collection-files-toolbar"
      className="flex items-center justify-between gap-md"
    >
      <SearchInput
        value={searchQuery}
        onChange={onSearchChange}
        placeholder={t('knowledgeBases.collectionFilesToolbar.searchFiles')}
        aria-label={t('knowledgeBases.collectionFilesToolbar.searchFilesLabel')}
        clearable
        size="lg"
        className="w-[420px]"
      />
      <Button variant="default" size="lg" onClick={onUpload} disabled={!canUpload}>
        <UploadIcon data-testid="upload-file-icon" />
        {t('knowledgeBases.collectionFilesToolbar.uploadFile')}
      </Button>
    </div>
  );
}

CollectionFilesToolbar.displayName = 'CollectionFilesToolbar';
